// extracted by css-extract-rspack-plugin
export default {"container":"_e876779d"};